'use client';

import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductColors({
  product,
  hideInvisible = false,
}: {
  product: Product;
  hideInvisible?: boolean;
}) {
  const colors = product.attributes?.find(attr => attr.id === 1)?.values;

  const hasColors = colors && colors.length > 0;

  if (!hasColors && !hideInvisible) {
    return <div className="invisible h-[23px] w-full" />;
  }

  return (
    <div className="flex w-full items-center justify-start gap-[2px]">
      {colors?.map(color => (
        <div
          key={color.id}
          className={cn(
            'relative z-10 h-[23px] w-[23px] shrink-0 rounded-full border-[3px] border-input',
            'ea-product-color',
          )}
          style={{ backgroundColor: color.color || '#000' }}
        />
      ))}
    </div>
  );
}
